import React, { useState, useEffect, useRef } from "react";
import Fuse from "fuse.js";
import { useNavigate } from "react-router-dom";

import "./RelatedDataVis.css";
import linksData from "../../DataGallery/Data/AllDataGalleryData.json"; // Adjust the path as necessary

const fetchAndSetRelatedData = (selectedData, setRelatedData, setLoading) => {
  if (!selectedData) return;

  setLoading(true);

  const searchTerms = [
    selectedData["Name as it appears"],
    selectedData["Book title"],
    ...(selectedData.categories || []),
    selectedData["Location/region"],
    selectedData["Time period"],
    selectedData["Major award(s)"],
    selectedData.Level,
  ].filter(Boolean);

  // Initialize Fuse for fuzzy search
  const fuse = new Fuse(linksData, {
    keys: ["title", "categories", "author"], // Ensure the fields match those in your data
    threshold: 0.5, // Adjust the threshold for more or less fuzzy matches
  });

  // Perform fuzzy search for each search term separately
  let resultLinks = [];
  searchTerms.forEach((term) => {
    const results = fuse.search(term).map(({ item }) => item);
    resultLinks = [...resultLinks, ...results];
  });

  // Remove duplicates
  const uniqueResults = Array.from(
    new Set(resultLinks.map((a) => a.title))
  ).map((title) => {
    return resultLinks.find((a) => a.title === title);
  });

  // Log the results for debugging
  console.log("Search Terms:", searchTerms);
  console.log("Fuzzy Search Results:", uniqueResults);

  // Shuffle the data
  const shuffledData = uniqueResults.slice(0, 15);

  setRelatedData(shuffledData);
  setLoading(false);
};

const TagButton = ({ children, onClick }) => (
  <button
    onClick={onClick}
    style={{
      display: "flex",
      padding: "6px 12px",
      alignItems: "center",
      gap: "4px",
      borderRadius: "8px",
      border: "0.25px solid var(--Gray-Black, #00000090)",
      background: "transparent",
      cursor: "pointer",
      color: "#00000090",
    }}
  >
    {children}
  </button>
);

const RelatedDataVis = ({ selectedData }) => {
  const [relatedData, setRelatedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const containerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAndSetRelatedData(selectedData, setRelatedData, setLoading);
  }, [selectedData]);

  const scrollLeft = () => {
    if (containerRef.current) {
      const scrollAmount = containerRef.current.clientWidth / 5;
      containerRef.current.scrollLeft -= scrollAmount;
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      const scrollAmount = containerRef.current.clientWidth / 5;
      containerRef.current.scrollLeft += scrollAmount;
    }
  };

  const handleDataVisclick = (dataVis) => {
    const dataVisId = dataVis.id || dataVis._id; // Ensure you use the correct identifier
    if (dataVisId) {
      navigate(`/dataVis/${dataVisId}`, { state: { dataVis } });
    } else {
      console.error("dataVis ID is missing", dataVis);
    }
  };
  const handleTagClick = (category) => {
    navigate(`/datavis?category=${encodeURIComponent(category)}`);
  };

  return (
    <div>
      <p className="section-title-related">
        {" "}
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.25281 4.8136C8.25281 4.26659 8.47011 3.74198 8.8569 3.35519C9.24369 2.9684 9.7683 2.7511 10.3153 2.7511H11.6903C12.2373 2.7511 12.7619 2.9684 13.1487 3.35519C13.5355 3.74198 13.7528 4.26659 13.7528 4.8136V6.1886C13.7528 6.73561 13.5355 7.26021 13.1487 7.64701C12.7619 8.0338 12.2373 8.2511 11.6903 8.2511V9.6261H19.2528C19.4351 9.6261 19.61 9.69853 19.7389 9.82746C19.8679 9.95639 19.9403 10.1313 19.9403 10.3136V11.6886C19.9403 11.8709 19.8679 12.0458 19.7389 12.1747C19.61 12.3037 19.4351 12.3761 19.2528 12.3761C19.0705 12.3761 18.8956 12.3037 18.7667 12.1747C18.6377 12.0458 18.5653 11.8709 18.5653 11.6886V11.0011H11.6903V11.6886C11.6903 11.8709 11.6179 12.0458 11.4889 12.1747C11.36 12.3037 11.1851 12.3761 11.0028 12.3761C10.8205 12.3761 10.6456 12.3037 10.5167 12.1747C10.3877 12.0458 10.3153 11.8709 10.3153 11.6886V11.0011H3.44031V11.6886C3.44031 11.8709 3.36787 12.0458 3.23894 12.1747C3.11001 12.3037 2.93514 12.3761 2.75281 12.3761C2.57047 12.3761 2.3956 12.3037 2.26667 12.1747C2.13774 12.0458 2.06531 11.8709 2.06531 11.6886V10.3136C2.06531 10.1313 2.13774 9.95639 2.26667 9.82746C2.3956 9.69853 2.57047 9.6261 2.75281 9.6261H10.3153V8.2511C9.7683 8.2511 9.24369 8.0338 8.8569 7.64701C8.47011 7.26021 8.25281 6.73561 8.25281 6.1886V4.8136ZM11.6903 6.8761C11.8726 6.8761 12.0475 6.80367 12.1764 6.67473C12.3054 6.5458 12.3778 6.37093 12.3778 6.1886V4.8136C12.3778 4.63126 12.3054 4.45639 12.1764 4.32746C12.0475 4.19853 11.8726 4.1261 11.6903 4.1261H10.3153C10.133 4.1261 9.9581 4.19853 9.82917 4.32746C9.70024 4.45639 9.62781 4.63126 9.62781 4.8136V6.1886C9.62781 6.37093 9.70024 6.5458 9.82917 6.67473C9.9581 6.80367 10.133 6.8761 10.3153 6.8761H11.6903ZM0.00280762 15.8136C0.00280762 15.2666 0.220106 14.742 0.6069 14.3552C0.993694 13.9684 1.5183 13.7511 2.06531 13.7511H3.44031C3.98732 13.7511 4.51192 13.9684 4.89872 14.3552C5.28551 14.742 5.50281 15.2666 5.50281 15.8136V17.1886C5.50281 17.7356 5.28551 18.2602 4.89872 18.647C4.51192 19.0338 3.98732 19.2511 3.44031 19.2511H2.06531C1.5183 19.2511 0.993694 19.0338 0.6069 18.647C0.220106 18.2602 0.00280762 17.7356 0.00280762 17.1886V15.8136ZM2.06531 15.1261C1.88297 15.1261 1.7081 15.1985 1.57917 15.3275C1.45024 15.4564 1.37781 15.6313 1.37781 15.8136V17.1886C1.37781 17.3709 1.45024 17.5458 1.57917 17.6747C1.7081 17.8037 1.88297 17.8761 2.06531 17.8761H3.44031C3.62264 17.8761 3.79751 17.8037 3.92644 17.6747C4.05537 17.5458 4.12781 17.3709 4.12781 17.1886V15.8136C4.12781 15.6313 4.05537 15.4564 3.92644 15.3275C3.79751 15.1985 3.62264 15.1261 3.44031 15.1261H2.06531ZM8.25281 15.8136C8.25281 15.2666 8.47011 14.742 8.8569 14.3552C9.24369 13.9684 9.7683 13.7511 10.3153 13.7511H11.6903C12.2373 13.7511 12.7619 13.9684 13.1487 14.3552C13.5355 14.742 13.7528 15.2666 13.7528 15.8136V17.1886C13.7528 17.7356 13.5355 18.2602 13.1487 18.647C12.7619 19.0338 12.2373 19.2511 11.6903 19.2511H10.3153C9.7683 19.2511 9.24369 19.0338 8.8569 18.647C8.47011 18.2602 8.25281 17.7356 8.25281 17.1886V15.8136ZM10.3153 15.1261C10.133 15.1261 9.9581 15.1985 9.82917 15.3275C9.70024 15.4564 9.62781 15.6313 9.62781 15.8136V17.1886C9.62781 17.3709 9.70024 17.5458 9.82917 17.6747C9.9581 17.8037 10.133 17.8761 10.3153 17.8761H11.6903C11.8726 17.8761 12.0475 17.8037 12.1764 17.6747C12.3054 17.5458 12.3778 17.3709 12.3778 17.1886V15.8136C12.3778 15.6313 12.3054 15.4564 12.1764 15.3275C12.0475 15.1985 11.8726 15.1261 11.6903 15.1261H10.3153ZM16.5028 15.8136C16.5028 15.2666 16.7201 14.742 17.1069 14.3552C17.4937 13.9684 18.0183 13.7511 18.5653 13.7511H19.9403C20.4873 13.7511 21.0119 13.9684 21.3987 14.3552C21.7855 14.742 22.0028 15.2666 22.0028 15.8136V17.1886C22.0028 17.7356 21.7855 18.2602 21.3987 18.647C21.0119 19.0338 20.4873 19.2511 19.9403 19.2511H18.5653C18.0183 19.2511 17.4937 19.0338 17.1069 18.647C16.7201 18.2602 16.5028 17.7356 16.5028 17.1886V15.8136ZM18.5653 15.1261C18.383 15.1261 18.2081 15.1985 18.0792 15.3275C17.9502 15.4564 17.8778 15.6313 17.8778 15.8136V17.1886C17.8778 17.3709 17.9502 17.5458 18.0792 17.6747C18.2081 17.8037 18.383 17.8761 18.5653 17.8761H19.9403C20.1226 17.8761 20.2975 17.8037 20.4264 17.6747C20.5554 17.5458 20.6278 17.3709 20.6278 17.1886V15.8136C20.6278 15.6313 20.5554 15.4564 20.4264 15.3275C20.2975 15.1985 20.1226 15.1261 19.9403 15.1261H18.5653Z"
            fill="white"
          />
        </svg>{" "}
        Related Data Visualizations
      </p>
      <div className="Related-data-wrapper">
        <button onClick={scrollLeft} className="nav-button lft-btn-Related">
          <img
            src="/leftArrow.svg"
            alt="Left arrow see more related data visualizations"
          ></img>
        </button>
        <div ref={containerRef} className="Related-data-container">
          {loading ? (
            <p>Loading...</p>
          ) : (
            relatedData.map((data, index) => (
              <div
                key={index}
                className="Related-data"
                onClick={() => handleDataVisclick(data)}
              >
                {data.image && (
                  <img src={data.image} alt={`Cover of ${data.title}`} />
                )}
                <div className="Related-data-info">
                  <i>
                    <p className="title">{data.title}</p>
                  </i>
                  <div className="tagbuttons">
                    {data.categories.map((category, categoryIndex) => (
                      <TagButton
                        key={categoryIndex}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleTagClick(category);
                        }}
                      >
                        {category}
                      </TagButton>
                    ))}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        <button onClick={scrollRight} className="nav-button rt-btn-Related">
          <img
            src="/rightArrow.svg"
            alt="Right arrow see more related data visualizations"
          ></img>
        </button>
      </div>
    </div>
  );
};

export default RelatedDataVis;
